import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider, useSelector } from 'react-redux';
import { Talkr } from 'talkr';
import { HashRouter, Routes, Route } from 'react-router-dom';
import questions from './survey/questions';
import store from './store';
import Menu from './components/menu';
import { questionsData } from './survey/questionsData';
import steps from './survey/stepsV2';
import * as configs from './survey/configs';
import buildConfig from './survey/buildConfig';
import Loader from './components/loader';
import defaultLang from './en.json';
import ViewportSizes from './components/viewport';
import focusFix from './utils/scripts/focusFix';
import getParameterFromURL from './utils/scripts/getParameterFromURL';
import firebaseConfig from './firebaseConfig';
import replaceUrl from './utils/scripts/replaceUrl';
import { initOneTrustTracking } from './utils/scripts/initOneTrustTracking';
import setButtonPosition from './utils/scripts/setButtonPosition';
import { initAmplitude } from './analytics/amplitude';
import { initTikTokPixel } from './analytics/initTikTokPixel';
import { initGoogleAds } from './analytics/initGoogleAds';
// import saveRandomValue from './utils/scripts/saveRandomValue';

// Pages
import Steps from './pages/steps';

import './index.scss';
import s from './app.module.scss';

window.dataLayer = window.dataLayer || [];
initAmplitude();
initTikTokPixel();
initGoogleAds();
firebaseConfig();
replaceUrl();
initOneTrustTracking();
const tariff = getParameterFromURL('tariff') || null;
// const configURL = getParameterFromURL('config') || null;
const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
const everydoggyV6 = getParameterFromURL('everydoggyV6') === 'true';
// const mix = getParameterFromURL('mix') === 'true';
const darkTheme = getParameterFromURL('darkTheme') === 'true';

// if (configURL === 'customV2' && everydoggyV5 && tariff === 'v31' && !mix) {
//   saveRandomValue(3, 'p13v1_firstScreen_title', 'A', 'B', 'C', 40, 30, 30);
// }

// if (configURL === 'customV2' && everydoggyV5 && tariff === 'v31' && mix) {
//   saveRandomValue(3, 'p13_mix_firstScreen_title', 'A', 'B', 'C', 40, 30, 30);
// }

if (getParameterFromURL('darkTheme') === 'true') {
  document.body.classList.add('dark');
}

let userLang = window.navigator.language.slice(0, 2);
const initHeight = window.visualViewport.height;

function App() {
  const showSteps = useSelector((state) => state.global.showSteps);
  const showLoader = useSelector((state) => state.global.showLoader);
  const initialAge = useSelector((state) => state.global.initialAge);
  const initialRole = useSelector((state) => state.global.initialRole);
  const stepsList = useSelector((state) => state.steps.list);
  const config = useSelector((state) => state.steps.config);
  const currentStepIndex = useSelector((state) => state.steps.currentStepIndex);
  const customV45 = getParameterFromURL('customV45') === 'true';
  const customV48 = getParameterFromURL('customV48') === 'true';

  useEffect(() => {
    localStorage.removeItem('bags');
  }, []);
  
  let configToApply;

  if (config === 'customV2') {
    // if (configURL === 'customV2' && everydoggyV5 && tariff === 'v31' && localStorage.getItem('p13_mix_firstScreen_title') === 'B' && mix) {
    //   configToApply = configs.customV35;
    // } else if (configURL === 'customV2' && everydoggyV5 && tariff === 'v31' && localStorage.getItem('p13_mix_firstScreen_title') === 'C' && mix) {
    //   configToApply = configs.customV36;
    // } else if (tariff && tariff === 'v17') {
    if (tariff && tariff === 'v17') {
      configToApply = configs.customV2;
    } else if ((!tariff && !everydoggyV6) || everydoggyV5) {
      if (!tariff) {
        if (everydoggyV5) {
          // const firstScreenAB = localStorage.getItem('p10_firstScreens_zw');
          // const firstScreenAB = true;

          // if (firstScreenAB) {
          //   configToApply = configs.customV29;
          // } else {
          configToApply = configs.customV27;
          // }
        } else {
          configToApply = configs.customV27;
        }
      } else {
        configToApply = configs.customV18;
      }
    } else if (config === 'customV32') {
      configToApply = configs.customV32;
    } else {
      configToApply = configs.customV18;
    }
  } else if (config === 'customV33') {
    configToApply = configs.customV33;
  } else {
    configToApply = (config && config in configs) ? configs[config] : configs.defaultConfig;
  }

  const isConfigShort = useSelector((state) => state.steps.config === 'short');
  const onbordingVersion = getParameterFromURL('config') ? getParameterFromURL('config') : '';

  useEffect(() => {
    const onLoad = () => {
      setTimeout(() => {
        const { loadEventEnd, navigationStart } = performance.timing;
        const loadTime = (loadEventEnd - navigationStart) / 1000;

        if (loadEventEnd > 0 && loadTime > 0) {
          steps.analytics.send({
            event: {
              event: 'onboarding_loading',
              loading_time: loadTime,
            },
          });
        } else {
          console.warn('Метрика загрузки некорректна:', loadTime);
        }
      }, 0);
    };

    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad);
      return () => window.removeEventListener('load', onLoad);
    }
  }, []);

  function setHeight() {
    const textHeight = 'px';
    document.querySelector('html').style.height = window.visualViewport.height + textHeight;
    document.documentElement.style.setProperty('--viewportHeight', window.visualViewport.height);
    if (document.querySelector('.stepContentWrapper')) {
      document.querySelector('.stepContentWrapper').style.minHeight = window.visualViewport.height - 82 + textHeight;
    }
    if (document.querySelector('.application')) {
      document.querySelector('.application').style.minHeight = window.visualViewport.height + textHeight;
    }
    
    if (document.querySelector('.bottomBar')) {
      const arrBottomBar = document.querySelectorAll('.bottomBar');
      if (arrBottomBar) {
        if (initHeight > window.visualViewport.height) {
          for (let i = 0; i < arrBottomBar.length; i++) {
            arrBottomBar[i].style.top = window.visualViewport.height - 82 + textHeight;
          }
        } else {
          for (let i = 0; i < arrBottomBar.length; i++) {
            arrBottomBar[i].style.top = window.visualViewport.height - 82 + textHeight;
          }
        }
      }
    }
  }
  setHeight();
  setInterval(setHeight, 2);

  if (window.innerWidth < 566) {
    if (/Android/i.test(navigator.userAgent)) {
      setButtonPosition();
      setInterval(setButtonPosition, 2);
    }
  }

  useEffect(() => {
    document.addEventListener('touchmove', (event) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });
  
    document.addEventListener('gesturestart', (event) => {
      event.preventDefault();
    });
    document.addEventListener('gesturechange', (event) => {
      event.preventDefault();
    });
    document.addEventListener('gestureend', (event) => {
      event.preventDefault();
    });

    const initHeightValue = sessionStorage.getItem('initHeightValue');
    const viewportHeightValue = sessionStorage.getItem('viewportHeightValue');
    const reload = sessionStorage.getItem('reload');
    window.initHeight = window.visualViewport.height;

    if (!initHeightValue) {
      sessionStorage.setItem('initHeightValue', window.visualViewport.height);
    }

    if (!viewportHeightValue) {
      sessionStorage.setItem('viewportHeightValue', window.visualViewport.height);
    }

    if (viewportHeightValue && initHeightValue && !reload) {
      setTimeout(() => {
        if (Number(viewportHeightValue) !== window.visualViewport.height) {
          sessionStorage.setItem('viewportHeightValue', initHeightValue);
          sessionStorage.setItem('reload', true);
        }
      }, 1000);
    }
  }, []);

  useEffect(() => {
    let startY = 0;
    const reload = sessionStorage.getItem('reload');

    const handleTouchStart = (event) => {
      startY = event.touches[0].clientY;
    };

    const handleTouchMove = (event) => {
      const currentY = event.touches[0].clientY;

      if (currentY > startY) {
        sessionStorage.setItem('reload', '');
      } else if (currentY < startY && reload) {
        sessionStorage.setItem('reload', '');
      } 
    };

    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  useEffect(() => {
    if (stepsList) return;
    questions.setup({
      questionsData,
    });

    if (config === 'customV1') {
      focusFix();
    }

    const configOptions = {
      config: configToApply,
      configName: config,
    };
    
    if (isConfigShort) {
      Object.assign(configOptions, { role: initialRole });
    } else {
      Object.assign(configOptions, { age: initialAge });
    }
    steps.setup({
      stepsConfig: buildConfig(configOptions),
      currentStep: configToApply[0].name,
      stepsDetails: configs.stepsDetails,
    });
  }, []);

  useEffect(() => {
    if (!window.loadEvent) {
      let pageUrlValue;
      let paymentVersion;
      if (getParameterFromURL('config') === 'customV1') {
        pageUrlValue = 'version1';
      } else if ((getParameterFromURL('config') === 'customV2') && (getParameterFromURL('sv') !== '2')) {
        pageUrlValue = 'v1';
      } else if ((getParameterFromURL('config') === 'customV2') && (getParameterFromURL('sv') === '2')) {
        pageUrlValue = 'v2';
      } else if (getParameterFromURL('config') === 'customV3') {
        pageUrlValue = 'v3';
      } else if (getParameterFromURL('config') === 'customV4' && getParameterFromURL('imgV') !== '2') {
        pageUrlValue = 'v4';
      } else if (getParameterFromURL('config') === 'customV5') {
        pageUrlValue = 'v5';
      } else if (getParameterFromURL('config') === 'customV6' && getParameterFromURL('sv') !== '3') {
        pageUrlValue = 'v6';
      } else if (getParameterFromURL('config') === 'customV6' && getParameterFromURL('sv') === '3') {
        pageUrlValue = 'v7';
      } else if (getParameterFromURL('config') === 'customV4' && getParameterFromURL('imgV') === '2') {
        pageUrlValue = 'v8';
      } else if (getParameterFromURL('config') === 'customV7') {
        pageUrlValue = 'v9';
      } else if (getParameterFromURL('config') === 'customV10') {
        pageUrlValue = 'v10';
      } else if (getParameterFromURL('config') === 'customV11') {
        pageUrlValue = 'v11';
      } else if (getParameterFromURL('config') === 'customV12') {
        pageUrlValue = 'v12';
      } else if (getParameterFromURL('config') === 'customV13') {
        pageUrlValue = 'v13';
      } else if (getParameterFromURL('config') === 'customV14') {
        pageUrlValue = 'v14';
      } else if (getParameterFromURL('config') === 'customV15') {
        pageUrlValue = 'v15';
      } else if (getParameterFromURL('config') === 'customV16') {
        pageUrlValue = 'v16';
      } else if (getParameterFromURL('config') === 'customV17') {
        pageUrlValue = 'v17';
      } else if (getParameterFromURL('config') === 'customV18') {
        pageUrlValue = 'v18';
      } else if (getParameterFromURL('config') === 'customV20') {
        pageUrlValue = 'v20';
      } else if (getParameterFromURL('config') === 'customV21') {
        pageUrlValue = 'v21';
      } else if (getParameterFromURL('config') === 'customV25') {
        pageUrlValue = 'v25';
      } else if (getParameterFromURL('config') === 'customV28') {
        pageUrlValue = 'v28';
      } else if (getParameterFromURL('config') === 'customV29') {
        pageUrlValue = 'v29';
      } else if (getParameterFromURL('config') === 'customV32') {
        pageUrlValue = 'v32';
      } else if (getParameterFromURL('config') === 'customV33') {
        pageUrlValue = 'v33';
      } else if (getParameterFromURL('config') === 'customV37') {
        pageUrlValue = 'v37';
      } else if (getParameterFromURL('config') === 'customV38') {
        pageUrlValue = 'v38';
      } else if (getParameterFromURL('config') === 'customV39') {
        pageUrlValue = 'v39';
      } else if (getParameterFromURL('config') === 'customV40') {
        pageUrlValue = 'v40';
      } else if (getParameterFromURL('config') === 'customV41') {
        pageUrlValue = 'v41';
      } else if (getParameterFromURL('config') === 'customV42') {
        pageUrlValue = 'v42';
      } else if (getParameterFromURL('config') === 'customV43') {
        pageUrlValue = 'v43';
      } else if (getParameterFromURL('config') === 'customV44') {
        pageUrlValue = 'v44';
      } else if (getParameterFromURL('config') === 'customV45') {
        pageUrlValue = 'v45';
      } else if (getParameterFromURL('config') === 'customV47') {
        pageUrlValue = 'v47';
      } else if (getParameterFromURL('config') === 'customV48') {
        pageUrlValue = 'v48';
      } else if (getParameterFromURL('config') === 'customV49') {
        pageUrlValue = 'v49';
      } else if (!getParameterFromURL('config')) {
        pageUrlValue = 'v1';
      } else {
        pageUrlValue = '';
      }
  
      if (getParameterFromURL('everydoggyV3') === 'true') {
        paymentVersion = 'p4';
      } else if (getParameterFromURL('tariff') === 'v8') {
        paymentVersion = 'p2';
      } else if (getParameterFromURL('tariff') === 'v6') {
        paymentVersion = 'p3';
      } else if (getParameterFromURL('tariff') === 'v10') {
        paymentVersion = 'p5';
      } else if (getParameterFromURL('tariff') === 'v14') {
        paymentVersion = 'p6';
      } else if (getParameterFromURL('everydoggyV4') === 'true') {
        paymentVersion = 'p7';
      } else if (getParameterFromURL('tariff') === 'v17') {
        paymentVersion = 'p8';
      } else if (getParameterFromURL('tariff') === 'v19') {
        paymentVersion = 'p9';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && (!getParameterFromURL('tariff') || tariff === 'v21')) {
        paymentVersion = 'p10';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v27') {
        paymentVersion = 'p11';
      } else if (getParameterFromURL('everydoggyV6') === 'true' && !getParameterFromURL('tariff')) {
        paymentVersion = 'p12';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v29') {
        paymentVersion = 'p14';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v31' && !getParameterFromURL('mix')) {
        paymentVersion = 'p13';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v31' && getParameterFromURL('mix') === 'true') {
        paymentVersion = 'p13_mix';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v39' && !getParameterFromURL('mix')) {
        paymentVersion = 'p19';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v41' && !darkTheme) {
        paymentVersion = 'p20';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v41' && darkTheme) {
        paymentVersion = 'p20_dark';
      // } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v41' && !getParameterFromURL('mix')) {
      //   paymentVersion = 'p20';
      } else if (getParameterFromURL('everydoggyV5') === 'true' && getParameterFromURL('tariff') === 'v43' && !darkTheme) {
        paymentVersion = 'p24';
      } else {
        paymentVersion = 'p1';
      }
  
      if (getParameterFromURL('showWeekPrice') === 'true') {
        paymentVersion += 'week';
      }
  
      window.loadEvent = true;
      steps.analytics.send({
        event: {
          event: 'onboarding_question',
          quiz_question: 'page_load',
          quiz_answer: pageUrlValue,
          payment_type: paymentVersion,
          link: `${pageUrlValue}${paymentVersion}`,
        },
      });
      localStorage.setItem('link', `${pageUrlValue}${paymentVersion}`);
    }
  }, []);

  useEffect(() => {
    if (currentStepIndex && stepsList && stepsList.length && !customV45 && !customV48) {
      if (stepsList[currentStepIndex]?.name === 'customV2_email') {
        // START ADD receive_email step

        const firebase = window.firebaseConfigData;
        const receiveEmail = firebase?.receive_email === 'true';
        const hasreceiveEmailStep = stepsList.some(
          (step) => step.name === 'receive_email',
        ); 
        if (receiveEmail && !hasreceiveEmailStep) {
          steps.addStepToEnd({ name: 'receive_email' });
        }

        // END ADD receive_email step

        // START AB TEST p20v1_discountScreenAnimatedGifts
        const hasSpecialOfferStep = stepsList.some(
          (step) => step.name === 'customV2_specialOffer_v2',
        );

        if (!hasSpecialOfferStep && !darkTheme) {
          steps.addStepToEnd({ name: 'customV2_specialOffer_v2' });
        }

        // END AB TEST p20v1_discountScreenAnimatedGifts
      }

      // console.log(stepsList);
    }
  }, [currentStepIndex]);

  return (
    <div className={`${s.app} ${onbordingVersion} application`}>
      {showSteps && !showLoader && <Steps />}
      {showLoader && <Loader />}
    </div>
  );
}

function Localisations(props) {
  const forceLang = useSelector((state) => state.global.forceLang);
  const [userLocale, setUserLocale] = useState(false);
  const allowedLanguages = ['en', 'ru', 'es', 'fr', 'de', 'pt', 'it', 'tr', 'pl', 'uk'];

  useEffect(() => {
    const selectedLang = allowedLanguages.includes(userLang) ? userLang : 'en';

    fetch(`./locales/${forceLang || selectedLang}.json`)
      .then((response) => response.json())
      .then((data) => {
        setUserLocale(data);
        window.locales = data;
        window.userLang = selectedLang;
        document.querySelector('html').lang = selectedLang;
      })
      .catch(() => {
        userLang = 'en';
        window.userLang = 'en';
        window.locales = defaultLang;
        setUserLocale(defaultLang);
      });

    window.defaultLocales = defaultLang;
  }, []);

  return (
    userLocale && (
      <Talkr
        languages={{ en: defaultLang, [userLang]: userLocale }}
        defaultLanguage="en"
        detectBrowserLanguage
      >
        {props.children}
      </Talkr>
    )
  );
}

const root = createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Provider store={store}>
      <React.StrictMode>
        <Localisations>
          <Routes>
            <Route path="/" element={<App />} />
          </Routes>
          <Menu />
          <ViewportSizes />
        </Localisations>
      </React.StrictMode>
    </Provider>
  </HashRouter>,
);
